import React, { Component, Fragment } from 'react'
import { Link } from 'react-router-dom'
import AuthService from '../../services/auth.service'

export class Ver_user_menu extends Component {
    render() {
        var handleLogout = this.props.handler;
        const user = AuthService.getCurrentUser();
        const name     = user && user.name     ? user.name     : '';
        const lastName = user && user.last_name ? user.last_name : '';
        const initials = ((name.charAt(0)) + (lastName.charAt(0))).toUpperCase() || 'A';
        const fullName = [name, lastName].filter(Boolean).join(' ') || 'Administrador';

        return (
            <Fragment>
                <li className="onhover-dropdown">
                    <div className="media align-items-center" style={{ gap: 8, cursor: 'pointer' }}>
                        <div style={{
                            width: 38, height: 38, borderRadius: '50%',
                            background: 'linear-gradient(135deg, #27ae60, #2ecc71)',
                            color: '#fff', display: 'flex', alignItems: 'center',
                            justifyContent: 'center', fontSize: 14, fontWeight: 700,
                            flexShrink: 0,
                        }}>
                            {initials}
                        </div>
                        <span style={{ fontSize: 13, fontWeight: 600, color: '#333', whiteSpace: 'nowrap' }}>
                            {fullName}
                        </span>
                    </div>
                    <ul className="profile-dropdown onhover-show-div p-20 profile-dropdown-hover">
                        <li><Link onClick={() => handleLogout()} to={`${process.env.PUBLIC_URL}/`}><i className="fa fa-sign-out" style={{ marginRight: 6 }} />Cerrar sesión</Link></li>
                    </ul>
                </li>
            </Fragment>
        )
    }
}

export default Ver_user_menu
